import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';

const PrimaryRedButton = styled(Button)({
    fontFamily: 'inherit',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    height: '48px',
    borderRadius: '28px',
    backgroundColor: '#FF2B1E',
    color: 'white',
    minWidth: '100px',
    gap: '10px',
    justifyContent: 'center',
    boxShadow: 'none',
    textTransform: 'unset',
    border: 'none',
    '&:hover': {
        backgroundColor: '#FF2B1E',
        borderColor: '#FF2B1E',
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: '#FF2B1E',
        borderColor: '#FF2B1E',
    },
})
export default PrimaryRedButton
